export const PAGE_NAMES = {
    home: '/goit-react-hw-08-phonebook',
    // home: '/',
    login: '/goit-react-hw-08-phonebook/login',
    register: '/goit-react-hw-08-phonebook/register',
    contacts:'/goit-react-hw-08-phonebook/contacts',
}